module.exports = __webpack_public_path__ + "img/LIST.eafa3e62.svg";